var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "18px",
    viewBox: "-0.5 -0.5 20 18",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-12-24T07:05:19.413Z\" agent=\"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/96.0.4664.110 Safari/537.36\" version=\"16.0.3\" etag=\"yB1p9NV6EyBO2M75ZKc1\" type=\"google\"><diagram id=\"KCz37bsG2SGAJ8a436d3\">jZRNb6MwEIZ/DcdFNgZijptsuj10pZV62LMLE7BiGGRMQvrr147NR1pVKhfwM+94xuMZInZop99a9M0frEBFCammiP2KkiSnSWpfjtw8oXmae1JrWQW2glf5DgGSQEdZwfAgNIjKyP4Rlth1UJoHJrTG66PshOoxai9q+AReS6E+03+yMo2nPCMrfwZZN3NkSoKlFbM4gKERFV43iB0jdtCIxn+10wGUq95cF+/39IV1SUxDZ77jkHiHi1BjOFvIy9zmww5nMKXLmkRsL4beF/QkJ7B77HuUnQF9vNiArqrUsuVQzqMSQ+OU90VjWjWLjMYzHFChtqTDzobbK/EG6i8O0kjsLC7BbW4NF9BG2gt4+SB4Q2Ow3Qh+Klk7g8HepRtWyz4nqdQcM0qYf3zKvTtvO9WuZ2PxPmqIS2z70TveM9uL8lxrHLvqQ94n7ExoU5qF9SbM0/2xPFTb5grTlzdGlz6wEwTYgtE3KwkOPxJCi9je3I6TtOC08BvMo8QKFvOU8LzI8iyhuzBq17VNKY/TLCnyouCEM85ZkDTbjs3jnOQsTdNdRq2U8TA8YXDqJa21t+xHaK95ubbx3bb5G7Djfw==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -0.22,
    y: -0.16,
    width: 18.45,
    height: 16.61,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.64 12.96 C 0.39 12.94 0.16 12.82 0.01 12.63 C -0.15 12.45 -0.22 12.21 -0.2 11.97 L -0.2 0.77 C -0.16 0.3 0.2 -0.07 0.67 -0.14 L 17.17 -0.14 C 17.72 -0.16 18.18 0.24 18.23 0.77 L 18.21 12.15 C 18.1 12.63 17.68 12.98 17.17 13 L 11.39 13 L 11.13 14.03 C 11.07 14.26 11.11 14.52 11.24 14.72 C 11.38 14.93 11.59 15.08 11.83 15.13 C 12.39 15.31 12.99 15.39 13.58 15.36 L 14.65 15.36 L 14.65 16.45 L 2.62 16.45 L 2.62 15.36 L 3.9 15.36 C 4.57 15.37 5.23 15.26 5.87 15.04 C 6.36 14.92 6.67 14.44 6.55 13.95 L 6.38 13 Z M 1.18 11.66 L 16.8 11.66 L 16.8 1.25 L 1.18 1.25 Z",
    fill: "#333333",
    stroke: "none",
    pointerEvents: "all"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerSvg);
export default __webpack_public_path__ + "static/media/computer-svg.1b6bf13781c61a56c6362f2aa33c9434.svg";
export { ForwardRef as ReactComponent };